const {AoflElement, store, ModalHandler} = aofljs;
/**
 * @summary CdivPage
 * @class CdivPage
 * @extends {AoflElement}
 */
class CdivPage extends AoflElement {
  /**
   * Creates an instance of CdivPage.
   * @memberof CdivPage
   */
  constructor() {
    super(store);
    new ModalHandler();
  }

  /**
   *
   * @readonly
   * @static
   * @memberof CdivPage
   */
  static get is() {
    return 'cdiv-page';
  }
}

window.customElements.define(CdivPage.is, CdivPage);



// WEBPACK FOOTER //
// ./cdiv/en-US/js/cdiv-page/cdiv-page.js